﻿(function (document) {
    document.addEventListener('DOMContentLoaded', function (e) {

        var form = document.querySelector('form');

        if (form == null) {
            return;
        }

        form.addEventListener('submit', function (e) {
            try {
                if (typeof (e.submitter) != 'undefined') {
                    var control = e.submitter;

                    if (typeof (control.dataset.trackingFunction) != 'undefined'
                        && control.dataset.trackingFunction != '') {
                        var trackingFunction = control.dataset.trackingFunction;
                        window[trackingFunction]();
                    }
                }
            }
            catch(err) { }
        });
    });
})(document);